import React from "react";
import { Link } from "react-router-dom";
import "./ThankYou.css";
export default function ThankYou() {
  return (
    <div className="thankyou ">
      <h1 style={{ textAlign: "center" }}>
        Všeobecné podmínky účasti na konferenci 24.9. v hotelu Passage,
        pořádanou University of Applied Management Inc., odštěpný závod & essential college, s.r.o. 
      </h1>
      <div style={{ margin: "2rem 1rem" }} className="padding">
        <p>
          - Organizátorem konference je University of Applied Management Inc.,
          odštěpný závod, Zapsána v obchodním rejstříku Městského soudu v Praze,
          oddíl A, vložka 76985, IČ: 03732177, DIČ: CZ683612206 & essential college, s.r.o., C 108607/KSBR Krajský soud v Brně, IČ: 07524609, DIČ: 	CZ07524609
        </p>
        <p>
          - Účastníkem konference se může stát řádně přihlášený nebo dohlášený
          zájemce.
        </p>
        <p>
          - Podmínkou účasti na konferenci je řádné vyplnění a odeslání
          přihlášky prostřednitvím elektronického formuláře.
        </p>
        <p>
          -Organizátor neuzavírá žádné pojištění pro účastníky konference.
          Účastníkům konference organizátor doporučuje sjednat vlastní úrazové
          připojištění korespondující s povahou zvolené exkurze. - V případě
          poškození majetku hotelu vaší vinnou, neneseme žádnou odpovědnost.
        </p>
        <p>
          -Přihlášením se na konferenci (odesláním přihlašovacího formuláře)
          účastník stvrzuje, že se s těmito VP důkladně seznámil a souhlasí s
          nimi.
        </p>
        <p>
          -Účastník bere na vědomí, že na konferenci bude pořizována
          fotografická a filmová dokumentace.
        </p>

        <button>
          <Link to="/">Zpět na registraci</Link>
        </button>
      </div>
    </div>
  );
}
